interface LogoProps {
  className?: string;
}

const Logo = ({ className }: LogoProps) => {
  return (
    <svg
      version="1.1"
      id="Layer_2_00000005949983768454771420000013466565790167129480_"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="439.4px"
      height="439.4px"
      viewBox="0 0 439.4 439.4"
      enableBackground="new 0 0 439.4 439.4"
      className={`${className} w-16 h-16`}
      fill="currentColor"
    >
      <g>
        <path
          d="M267.9,175.3l2.9-0.5v43.4c0,3.7-0.3,6.2-0.7,7.7c-0.3,1.1-1.2,2.8-2.6,5l22.8-6.1l-2.5-3.6
		c-0.5-1.5-0.8-4-0.8-7.3v-43.4l1.5-0.6l2-0.7l4.9-0.3l3.5,1.8l3-15.9l-42.3,11.4l-3.3,15.9l5.9-4.3L267.9,175.3L267.9,175.3
		L267.9,175.3z"
        />
        <path
          d="M198.5,245.3c-0.7,1.6-1.6,3.3-2.7,5l22.8-6.1l-2.6-3.6c-0.5-1.2-0.7-3.6-0.7-7.3v-18.4l18.4-5v18.4
		c0,3.4-0.2,5.9-0.6,7.5l-2.8,5.2l22.9-6.2c-1.1-0.9-2-2.2-2.7-3.7c-0.5-1.4-0.7-3.8-0.7-7.2v-43.2c0-3.7,0.2-6.2,0.7-7.7
		c0.4-1.5,1.3-3.2,2.6-5l-22.8,6.1c1.4,1,2.3,2.2,2.8,3.6c0.4,1.2,0.6,3.6,0.6,7.3v14.5l-18.4,5v-14.4c0-3.7,0.2-6.3,0.7-7.9
		c0.5-1.6,1.3-3.2,2.6-4.8l-22.8,6.1c1.1,0.8,2,1.9,2.7,3.3c0.5,1.8,0.7,4.4,0.7,7.6v43.2C199.2,240.6,198.9,243.2,198.5,245.3
		L198.5,245.3L198.5,245.3z"
        />
        <path
          d="M152.8,241.6c1.9,5.6,3.9,9.4,6.2,11.4c2.7,2.3,6.8,3.5,12.4,3.7l19.6-72.1l-14.7,3.9l2.4,3.4l0.8,3.4
		l-10.6,42.3L158.1,202l-1.9-8l-18.4,4.9l2.4,4.5L152.8,241.6L152.8,241.6L152.8,241.6z"
        />
        <path
          d="M292.2,90.4l-20-27.9l-21.6,30.2l-30.7-43.1L189,92.8l-21.7-30.3l-20,27.9h-46.4V95
		c0,0.8,0.3,81.8,0.4,129.2c0,43.4,21.1,84.6,56.2,110.3c29.5,21.6,60.1,35.1,60.4,35.2l1.8,0.8l1.8-0.8c0.3,0,31-13.6,60.3-35.2
		c35.1-25.7,56.2-66.9,56.3-110.4l0.3-133.7L292.2,90.4L292.2,90.4L292.2,90.4z M167.3,74.4l21.7,30.3l30.9-43.1l30.8,43.1
		l21.6-30.3l40.4,56.4L125,181.1l-0.2-47.3L167.3,74.4L167.3,74.4L167.3,74.4z M140.4,277.3c-9.9-18.1-15.3-38.6-15.4-59.8v-27.3
		l189.6-50.8l-0.2,78.1c0,4.4-0.2,8.9-0.8,13.4L140.4,277.3L140.4,277.3L140.4,277.3z M312.2,240.2c-5.9,31.7-24.1,60.2-51,79
		c-21.6,15.1-41.5,23.2-41.5,23.2s-19.9-8.1-41.5-23.2c-13.3-9.3-24.4-20.9-33-34.2L312.2,240.2z M331,223.8
		c0,41.1-19.7,79.7-52.8,104.1c-27.8,20.4-56.4,33-56.4,33l-2.1,0.9l-2.1-0.9c0,0-28.6-12.6-56.4-33.1
		c-33.1-24.3-52.7-62.9-52.8-104c0-44.9-0.3-120.9-0.3-120.9v-5.2h35.3L136,108h-17.5c0,17.8,0.2,77.9,0.3,115.7
		s18.2,73.3,48.6,95.7c22.4,16.6,45.4,27.8,52.3,31c6.9-3.2,29.9-14.4,52.3-30.9c30.5-22.4,48.5-58,48.6-95.8
		c0-37.9,0.3-97.8,0.3-115.7h-17.3l-7.4-10.3h35.1L331,223.8L331,223.8L331,223.8z"
        />
      </g>
    </svg>
  );
};

export default Logo;
